{
  "client": "Cliente",
  "marketValue": "Total de activos",
  "completedAt": "Completado en",
  "organization": "Organización",
  "previousInformationUpdate": "Actualización de la información anterior",
  "daysPastDue": "Días de retraso",
  "search": "Buscar",
  "days": "días",
  "table": {
    "organization": "Organización"
  }
}
